import React, { Fragment, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios';
import { UserContext } from '../../../Context/UserContext.js';
import { toast } from 'react-toastify';



export default function SpecificProfile() {
   const {userToken } = useContext(UserContext) ;
   const [profile , setProfile] = useState({}) ;
   const{id} = useParams () ;
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   //& Get Test Data and Current Page :
   const getSpecificProfile = async()=>{
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/profile/${id}`  ,  {headers:header})
      .then(({data})=>{
         setProfile(data?.profile) ;
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }

   useEffect(() => {
      getSpecificProfile(id)
   }, [])
   
   return (
      <Fragment>
         <div className="container mt-5">
            <h1 className='main-header'>Specific profile</h1>
            <div className='under-header'></div>

            <div className="row ">
               <div className="col-md-12 mb-4">
                  <h4 className='fw-bold'>profile Information :</h4>
                  <div className='border border-1 p-2 rounded-2'>

                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{profile.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Description:</th>
                              <td>{profile.description}</td>
                           </tr>
                           <tr>
                              <th scope="row">Price:</th>
                              <td>{profile.price}</td>
                           </tr>
                           <tr>
                              <th scope="row">State:</th>
                              <td>{profile.isActive? <p className='text-success'>Active profile</p> : <p className='text-danger'>Not Active profile</p>}</td>
                           </tr>
                           <tr>
                              <th scope="row">Created By :</th>
                              <td>{profile.createdBy?.name}</td>
                           </tr>
                        </tbody>
                     </table>
                     <div className='text-center'>
                        <img src={profile.image} alt={profile.name} className='w-50 '/>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
